document.querySelectorAll('.button-subscription').forEach((button) => {
  button.addEventListener('click', () => {
    localStorage.setItem('productRedirect', button.dataset.productPath);

    window.location.href = '/account';
  });
});

if (window.location.pathname === '/account') {
  const productRedirect = localStorage.getItem('productRedirect');

  localStorage.setItem('productRedirect', '');

  if (productRedirect && productRedirect != '')
    window.location.href = productRedirect;
}

/* apenas assinatura no carrinho - remover outros itens */
async function _temAssinaturaNoCarrinho(tituloProduto) {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  if(cart.items.some(item => item.title.includes('Assinatura'))){
    return 'Não é possível adicionar mais produtos - Tem produtos de assinatura no carrinho';
  } else if(cart.items.length > 0 && tituloProduto.includes('Assinatura')) {
    return 'Não é possível adicionar mais produtos - Tem produtos de assinatura no carrinho';
  } else {
    return false;
  }
}

(function observarCarrinho() {
  let ultimaExecucao = 0;
  const intervaloMinimo = 10 * 1000;
  // verificar se há assinatura no carrinho
  function temAssinatura(itens) {
      return itens.some(item => item.title.includes('Assinatura'));
  }
  // remover itens que não são assinatura
  async function removerItensNaoAssinatura(itens) {
      var removidos = 0;
      for (let item of itens) {
          if (!item.title.includes('Assinatura')) {
              removidos++;
              await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: 0 })
              });
          }
      }
      if(removidos > 0) window.location.reload();
  }
  // mudanças no carrinho
  let observer = new MutationObserver(async function() {
      const agora = Date.now();
      if (agora - ultimaExecucao < intervaloMinimo) return;
      ultimaExecucao = agora;
      // busca o carrinho
      console.log('buscando carrinho - validando assinatura');
      const response = await fetch('/cart.js');
      const cart = await response.json();        
      if (temAssinatura(cart.items)) {
          // se tem assinatura, remove outros produtos
          await removerItensNaoAssinatura(cart.items);
      }
  });    
  observer.observe(document.body, { childList: true, subtree: true });
})();


/* crie a função para funcionar, que se tiver /tagged/ na url, adiciona uma classe is-tagged no body */
(function verificarTagged() {
  if (window.location.pathname.includes('/tagged/')) {
    document.body.classList.add('is-tagged');
  }
})();

/* fechar popup mbz */
(function() {
    setInterval(function() {
        var body = document.body;
        if (body && body.classList.contains('mbz-popup-opened')) {
            body.classList.remove('mbz-popup-opened');
            var popup = document.querySelector('div[data-mbz-popup-shell]');
            if (popup) {
                popup.parentNode.removeChild(popup);
            }
        }
    }, 100);
})();
